<script>
  /**
   * ColorThumbnail - A semantic "Mini UI Card" that visualizes a color set.
   * 
   * Design:
   * - 3:2 aspect ratio (24x16 viewBox)
   * - Background fills area
   * - Text lines (foreground)
   * - Pill button (emphasis)
   * - CSS border for clean appearance
   */
  let {
    background,
    foreground,
    emphasis_background,
    emphasis_foreground = null,
    class: css_class = '',
  } = $props();
</script>

<svg 
  viewBox="0 0 24 16" 
  class="color-thumbnail {css_class}"
  role="img"
  aria-label="Color set preview"
>
  <!-- Background fills entire area -->
  <rect x="-1" y="-1" width="26" height="18" fill={background} />
  
  <!-- Text representation: two lines -->
  <rect x="5" y="3" width="14" height="1" rx="0.5" fill={foreground}/>
  <rect x="8" y="5" width="8" height="1" rx="0.5" fill={foreground}/>
  
  <!-- Button pill -->
  <rect x="7" y="10" width="10" height="4" rx="2" fill={emphasis_background}/>
  
  <!-- Button text indicator -->
  {#if emphasis_foreground}
    <rect x="10" y="11.5" width="4" height="1" rx="0.5" fill={emphasis_foreground}/>
  {/if}
</svg>

<style lang="postcss">
  .color-thumbnail {
    display: block;
    flex-shrink: 0;
    aspect-ratio: 3 / 2;
    overflow: hidden;
    border-radius: 4px;
    outline: 1px solid oklch(0 0 0 / 0.1);
    outline-offset: -1px;
    width: 100%;
  }
</style>
